import { createElement } from "react";
import './index.scss';
const ColorfulNavbar = function ColorfulNavbar({ title, back, backArrow, right, onBack, ...otherProps }) {
    const _otherProps = otherProps || {};
    const handleGoBackEvent = (e) => {
        if (onBack) {
            return onBack(e);
        }
    };
    return (createElement("div", { className: `au-navbar`, ..._otherProps },
        createElement("div", { className: `au-navbar-left`, role: 'button' }, back !== null && (createElement("div", { className: `au-navbar-back`, onClick: handleGoBackEvent },
            backArrow && (createElement("i", { className: `icon-angle-left` })),
            createElement("span", { className: "au-navbar-left-txt", "aria-hidden": 'true' }, back)))),
        createElement("div", { className: `au-navbar-title` }, title),
        createElement("div", { className: `au-navbar-right` }, right)));
};
ColorfulNavbar.displayName = 'ColorfulNavbar';
export default ColorfulNavbar;
